const css = require('./tos.css');
const $ = require('jquery');
let { raiseEvent } = require('../../../signals/analytics');

const { cut } = require('../../../helpers/utils');
const ACCEPT = cut(css.accept);
const CANCEL = cut(css.cancel);
const CONTAINER = cut(css.container);

class ToS {
    constructor () {
        this.template = require('./template.hbs');
        this.tabTrapBound = this.trapTab.bind(this);
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        $('body').addClass(css.scrollDisabled);

        document.addEventListener('focus', this.tabTrapBound, true);

        return {
            focus: {
                document: this.test
            },
            click: {
                [ACCEPT]: this.handleAccept,
                [CANCEL]: this.handleCancel
            }
        };
    }

    unbind () {
        document.removeEventListener('focus', this.tabTrapBound, true);
        $('body').removeClass(css.scrollDisabled);
    }

    trapTab (event) {
        let el = $(this.$context.element);
        let modal = el.find(CONTAINER)[0];
        if (!modal.contains(event.target)) {
            event.stopPropagation();
            modal.focus();
        }
    }

    handleCancel () {
        this.$context.signal(raiseEvent, { category: 'button_cancel_popup_agreement', action: 'click' });
        this.$context.signal(this.$context.props.signals.cancel);
    }

    handleAccept () {
        this.$context.signal(raiseEvent, { category: 'button_accept_popup_agreement', action: 'click' });
        this.$context.signal(this.$context.props.signals.accept);
    }
}

module.exports = {
    constructor: ToS
};



// WEBPACK FOOTER //
// ./components/auth/tos/index.js